
import { Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";

export default function FsButton(props: { handler: any }) {
    const { handler } = props
    return (
        <>
        {
            handler.active ?
                <Icon as={MdFullscreenExit} onClick={handler.exit} w='30px' h="30px" _hover={{ color: 'whiteAlpha.800', transform: 'scale(1.1)', transition: 'transform 0.1s' }} position='absolute' right='25px' top='-5px' />
                :
                <Icon as={MdFullscreen} onClick={handler.enter} w='30px' h="30px" _hover={{ color: 'whiteAlpha.800', transform: 'scale(1.1)', transition: 'transform 0.1s' }} position='absolute' right='25px' top='-5px' />
        }
        </>
    )
}